<template>
  <div class="col-lg-4 dashboard__box-col">
    <div :class="['box ', color]">
      <h2 class="h h--2">Twoje punkty</h2>

      <p class="dashboard__points dashboard__points--pro">
        Do wykorzystania obecnie:
      </p>
      <h3 class="dashboard__points">
        {{
          points > 0 ? parseFloat(points).toFixed(1).replace(".", ",") : 0
        }}
        pkt
      </h3>

      <div
        v-if="user.is_certyficated && user.points_to_loss >= 0"
        class="dashboard__points dashboard__points--pro dashboard__points--warning"
      >
        <b>{{ parseFloat(user.points_to_loss).toFixed(1) }} pkt</b>
        wykorzystaj<br />przed
        {{ moment(user.next_expire_date).format("DD.MM.YYYY") }}
      </div>

      <div>
        <router-link :to="{ name: 'PointsHistory' }" class="box__link"
          >&raquo; Historia</router-link
        >
      </div>

      <router-link :to="{ name: 'Prizes' }" class="button button__bottom"
        >Zamień na nagrody &raquo;</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "PointsWidget",
  props: {
    color: {
      default: "box--dark-blue",
    },
  },
  computed: {
    points() {
      return this.$store.state.user.total_points;
    },
    user() {
      return this.$store.state.user;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/points/PointsWidget.vue